export default __webpack_public_path__ + "menu-catalog-icon.1f77dc1bc6be3723b89c4692cd2e7ff0.svg";